var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _path8, _path9, _path10, _path11, _ellipse, _path12, _rect, _ellipse2, _ellipse3, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle, _path13, _g, _path14, _path15, _path16, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProfileImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-14,.cls-15,.cls-19{fill:none;}.cls-2{fill:#f1c391;}.cls-3{fill:#313236;}.cls-4{fill:#000333;}.cls-5{fill:#dab388;}.cls-6{fill:#d11414;}.cls-7{fill:#414141;}.cls-17,.cls-8{fill:#fff;}.cls-9{fill:#6d6e6e;}.cls-10{fill:#ccc;}.cls-11{fill:#231f20;}.cls-12{fill:#929191;}.cls-13,.cls-14{stroke:#a3a3a3;}.cls-13,.cls-14,.cls-15,.cls-19{stroke-linecap:round;}.cls-13,.cls-14,.cls-15,.cls-17{stroke-miterlimit:10;}.cls-13{stroke-width:2px;}.cls-15{stroke:#e5e5e5;stroke-width:0.25px;}.cls-16{clip-path:url(#clip-path);}.cls-17{stroke:#414141;}.cls-18{fill:#ffb48a;}.cls-19{stroke:#c11010;stroke-linejoin:round;stroke-width:0.5px;}.cls-20{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 94.15,
    cy: 41.6,
    r: 14.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.75,
    cy: 44.94,
    r: 14.66
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.27,142.36a26.66,26.66,0,0,1-.55,5.3l7,.86a28.23,28.23,0,0,0,1.48-6.22c.06-2.22-7.83-1.73-7.83-1.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.24,143.53s.28,2.91,2.82,3.34,4.66-1.93,5-2.92l.43.07.22,1.4s-1.76,10.43-3.23,12.77-6.28,1.51-7.21-.52c-.87-1.88.54-9.79.86-10.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.52,143.62l-.34,6.3-7.84-.34a45.2,45.2,0,0,0,.42-6.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.37,78.9s1.48,26.94-7,64.07l-8.88-.24s.87-37.59,1.24-44.73c0,0-4.93,24.77-5.8,28.46s-3.57,16.27-3.57,16.27l-8.62-1S14,115.87,14,112.17,14.23,87,16.69,77.64,43.37,78.9,43.37,78.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.59,8.49a38.3,38.3,0,0,1-2.44,15.82.83.83,0,0,1-.72.52c-1.86.1-8.22.24-11.5-2.44l-3-6.16,1.18-7L40,6.26l6.63,1.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.14,24A60.55,60.55,0,0,1,41,32.12l-4.75,2.59-6-3.58-.12-1.23a63.9,63.9,0,0,0,4.28-9.33l8,1.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.11,42.17l-8.6,1.12a1.8,1.8,0,0,0-1.68,1.47c-1.61,9.09-5.47,34.59-5.47,34.59-6.42,1.41-26.67-1.72-26.67-1.72C20,63.32,18.81,42.45,18.81,42.45c-.13-2.24.87-9,2.93-10.4a19.64,19.64,0,0,1,9.2-3.68c.42,1.94,2.76,3.76,5.22,4.1S41.45,30,41.45,30a20.27,20.27,0,0,1,4.46.13c1.94.36,10.54,3.7,10.54,3.7l-2.71,3.23,5.33,2.83Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.76 139.67 20.55 140.65 19.75 144.23 9.89 142.81 10.76 139.67"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.2 140.69 37.73 140.76 36.99 144.79 26.86 144.45 27.2 140.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.75,148.63a9.11,9.11,0,0,0,7.27,0,.57.57,0,0,1,.46,0,19.72,19.72,0,0,0,4.78,1.57c1.38,0,4.83,1,5.42,2.47s-.18,3.42-1,3.79-9.18-.5-10.47-.4c-1,.07-4.92,0-6.58-.06a.71.71,0,0,1-.7-.78l.52-6.39A.24.24,0,0,1,27.75,148.63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.91,9.08s6.67,1.71,9.2-.67A6.57,6.57,0,0,0,52,3.19C51.8,1.48,49,1.74,47.27,1.84c-.68,0-1.36,0-2.05.06a36.61,36.61,0,0,1-4.19,0c-1.94-.17-7.39.24-9.85,3.23a15.15,15.15,0,0,0-2.11,6.27c-.11,2.82,2.33,8.87,3.76,11.9a.49.49,0,0,0,.82.09A17.56,17.56,0,0,0,36,18.93a1,1,0,0,1-.88-.65c-.3-.64-.77-4.75.93-4.45,0,0,.72.19.83.69a1.9,1.9,0,0,1,.05.71s.14.78.68.27a15.66,15.66,0,0,0,1.58-2.58S40.05,9.08,40.91,9.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.8,157H92.33c-11.85,0-24.33.94-21.46-19.81V22.86C68,1.34,80.48,3.05,92.33,3.05H124.8c23.37-2,21.45,8.87,21.45,19.81V137.14C148.11,160.12,136.65,157,124.8,157Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M137,159.61H78.72c-6.3,0-11.42-4.73-11.42-10.54V10.93C67.3,5.12,72.42.39,78.72.39H137c6.29,0,11.41,4.73,11.41,10.54V149.07C148.43,154.88,143.31,159.61,137,159.61ZM78.72,5.7a5.47,5.47,0,0,0-5.67,5.23V149.07a5.47,5.47,0,0,0,5.67,5.23H137a5.47,5.47,0,0,0,5.66-5.23V10.93A5.47,5.47,0,0,0,137,5.7Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 109.38,
    cy: 8.73,
    rx: 1.03,
    ry: 0.95
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.08,142.92h57.64a6,6,0,0,1,6,6v5.4a0,0,0,0,1,0,0H73.09a0,0,0,0,1,0,0v-5.38A6,6,0,0,1,79.08,142.92Z",
    transform: "translate(215.77 297.21) rotate(180)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 95.95,
    y: 4.64,
    width: 26.85,
    height: 6.57,
    rx: 2.32
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 109.38,
    cy: 8.73,
    rx: 0.93,
    ry: 0.85
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 105.9,
    cy: 8.73,
    rx: 0.55,
    ry: 0.51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 73.09,
    y: 15.72,
    width: 69.6,
    height: 27.16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 79.49,
    y1: 59.39,
    x2: 107.94,
    y2: 59.39
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 80.41,
    y1: 65.64,
    x2: 107.02,
    y2: 65.64
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 88.37,
    y1: 80.96,
    x2: 77.45,
    y2: 80.96
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 103.07,
    y1: 80.96,
    x2: 91.05,
    y2: 80.96
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 117.76,
    y1: 80.96,
    x2: 105.75,
    y2: 80.96
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 128.61,
    y1: 80.96,
    x2: 122.4,
    y2: 80.96
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 119.92,
    y1: 80.78,
    x2: 119.92,
    y2: 75.05
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 138.52,
    y1: 80.96,
    x2: 132.32,
    y2: 80.96
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 77.45,
    y1: 92.65,
    x2: 137.96,
    y2: 92.65
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 67.77,
    cy: 47.83,
    r: 14.66
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.35,18.25l.29.67a2.49,2.49,0,0,0-.09-1C47.39,17.59,47.35,18.25,47.35,18.25Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 94.15,
    cy: 41.6,
    r: 13.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 94.15,
    cy: 37.92,
    r: 5.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 94.15,
    cy: 56.21,
    rx: 9.52,
    ry: 11.42
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M35.18,43.05s1.94,3.59,3.65,7.58c0,0,18.14,5,21.14,6.73l-2.28,2.5S41.25,58.74,34.3,56.33c0,0-6.44-7.82-7.21-9.75Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M35.07,43.23l-8,3s-5.13-7-6-12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M60,57.36s2.45,1.83,4.55,1.65,3.57-.37,3.15.69-3.16,1.86-4,1.85a14.21,14.21,0,0,1-6-1.69C55.73,58.61,60,57.36,60,57.36Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 65.75,
    cy: 44.94,
    r: 14.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.52,42.48s1.22-.62,1.43.54a2.62,2.62,0,0,1-.48,1.48,5.43,5.43,0,0,1-1.14,1,5,5,0,0,1-2.13,3.72,4.43,4.43,0,0,1-5,.07,5.35,5.35,0,0,1-2.18-3.52s-2.23-1.22-1.82-2.89a1,1,0,0,1,1.37-.15l.25-2.54,4.56-1.92,3.07-.76,1.47,1,.89,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.13,42.24a7.11,7.11,0,0,0,3.55-1.17,4.69,4.69,0,0,0,4.64-2s.23-.07.15.28c0,0,.09,2.93.9,4.07,0,0,.22.22.41-.14,0,0,1.28-4,.72-5.42a2.41,2.41,0,0,0-1.88-1.58,2.1,2.1,0,0,0,.22-1c-.09-.32-.74-.18-1.09.2,0,0-.28.1-.14-.24s.13-.84-.26-.85-.54.54-.72.59a5,5,0,0,0-5.36-.07S59.5,36,60,40.79a25.42,25.42,0,0,1,.6,3s.21.17.27,0A6.36,6.36,0,0,1,61.13,42.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.15,48.71a19.82,19.82,0,0,0,0,2.24l1.49.34L68.46,55s-3.21.93-3.25.93-2.43-1.68-2.43-1.68l-.62-3.06s.68-.13,1.21-.25c0,0,.05-1.44,0-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.1,53.06a29.27,29.27,0,0,1,5.1-1.93A15.6,15.6,0,0,0,65,54.25a1.88,1.88,0,0,0,1.61,0,20.84,20.84,0,0,0,2.65-3A23,23,0,0,1,74.51,53s1.26.17,2.06,2.37a39.08,39.08,0,0,1,1.67,4.79l-13.85,1L53.45,59a35.88,35.88,0,0,1,2.32-5.25A2.88,2.88,0,0,1,57.1,53.06Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileImg);
export default __webpack_public_path__ + "static/media/editProfileImg.ac94c920fb10976f200aa341b4ece03f.svg";
export { ForwardRef as ReactComponent };